var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGhostRoadMapTabsAdaptive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 46,
    viewBox: "0 0 573 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M148.556 24.2841V21.5H114.778V24.2841H148.556Z",
    fill: "white",
    stroke: "#1E2835"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3497 24.2841V21.5H45.5717V24.2841H79.3497Z",
    fill: "white",
    stroke: "#1E2835"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M202.222 24.3352H220.57V21.5H202.222H183.873V24.3352H202.222Z",
    fill: "white",
    stroke: "#1E2835"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M289.871 24.2841V21.5H256.093V24.2841H289.871Z",
    fill: "white",
    stroke: "#1E2835"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M343.536 24.3352H361.885V21.5H343.536H325.188V24.3352H343.536Z",
    fill: "white",
    stroke: "#1E2835"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M431.185 24.2841V21.5H397.407V24.2841H431.185Z",
    fill: "white",
    stroke: "#1E2835"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M484.851 24.3352H503.2V21.5H484.851H466.502V24.3352H484.851Z",
    fill: "white",
    stroke: "#1E2835"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M572.5 24.2841V21.5H538.722V24.2841H572.5Z",
    fill: "white",
    stroke: "#1E2835"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 23,
    r: 10,
    fill: "#1E2835",
    stroke: "#AEFF00"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 23,
    r: 5,
    fill: "#AEFF00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGhostRoadMapTabsAdaptive);
export default __webpack_public_path__ + "static/media/ghostRoadMapTabsAdaptive.e615da17819a4a0f3a5e346a7f7d05c9.svg";
export { ForwardRef as ReactComponent };